var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnectedOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.99 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "power-plug") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.11,55.54V66.28c0,21.68,9.63,32.29,31.73,35v21.64H57V101c21.88-2.1,31.73-15,31.73-36V55.54h3.16A5.12,5.12,0,0,0,97,50.43V44.52a5.12,5.12,0,0,0-5.1-5.11H76.73V8.08A8.11,8.11,0,0,0,68.64,0h0a8.11,8.11,0,0,0-8.08,8.08V39.41H36.84V8.08A8.11,8.11,0,0,0,28.76,0h0a8.1,8.1,0,0,0-8.08,8.08V39.41H5.1A5.12,5.12,0,0,0,0,44.52v5.91a5.12,5.12,0,0,0,5.1,5.11Zm42.81,9.1h4.62a1.22,1.22,0,0,1,1.21,1.22,1.16,1.16,0,0,1-.21.67l-11,18.79a1.21,1.21,0,0,1-2.25-.63,1,1,0,0,1,0-.24l1.62-11.53L40.47,73h0a1.2,1.2,0,0,1-1.21-1.18h0a1.26,1.26,0,0,1,.16-.63L50.24,52.41a1.21,1.21,0,0,1,2.25.62.81.81,0,0,1,0,.16l-.56,11.45Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedOrg);
export default __webpack_public_path__ + "static/media/connected_org.8da51fe01a689f9a66a9b888fe4e5135.svg";
export { ForwardRef as ReactComponent };